import { FC } from "react";
import styles from "./product-availability.module.css";
import { useProductAvailability } from "./product-availability.hook";
import { ProductAvailabilityProps } from "./product-availability.types";
import { TypeInventory } from "@commons-monorepo/index";

export const ProductAvailability: FC<ProductAvailabilityProps> = (props) => {
  const {
    t,
    product,
    textDisable,
    inventoryConfig,
    isInventoryAvailable,
    isAvailable
  } = useProductAvailability(props);

  return (
    <div
      className={`${styles.productDetailAvailability} ${
      styles[
      `productDetailAvailability__${
      !!product.kit ?
      TypeInventory.Always :
      inventoryConfig?.type.toUpperCase()
      }`]

      }`}
      aria-label='product-detail-availability'>

      <h3
        className={
        isAvailable ? styles.productDetailSectionTitle : styles.productOff}>


        {t("product.availability_porduct")}
        <span
          className={`${
          !isInventoryAvailable || !!product.kit ?
          styles.inventoryAvailabilityButton :
          ""
          } ${
          isAvailable ?
          styles.productDetailAvailabilityText :
          styles.productDetailAvailabilityTextOff
          }`}>

          {textDisable}
        </span>
      </h3>
      {!!product.inventory?.deliveryDays &&
      <div
        className={`${styles.productDetailAvailabilityOnRequest}`}
        data-testid='product-availability-text'>

          {t("product.on_request")}:
          <span>
            {t("product.on_request_days", {
            days: product.inventory?.deliveryDays
          })}
          </span>
        </div>}

    </div>);

};